exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.square {\n  width: 12.5%;\n  height: 0;\n  padding: 6.25% 0;\n  cursor: pointer;\n  text-align: center;\n  display: flex;\n  flex: 1 1 auto;\n  align-items: center;\n  position: relative;\n}\n.square-label {\n  font-size: 80%;\n  padding: 1px;\n  opacity: 0.5;\n  position: absolute;\n}\n.r0 {\n  right: 0;\n}\n.t0 {\n  top: 0;\n}\n.b0 {\n  bottom: 0;\n}\n.square:hover {\n  background: #88ccff !important;\n}\n", ""]);

// exports
